import { Box } from "@mui/material";

import { ToggleGroup } from "@/components/elements/ToggleGroup";
import { ScanTab, UseScanImageStateReturn } from "@/features/talent/components/talent-scan-image/useScanImageState";

type Props = {
  state: UseScanImageStateReturn;
};

const TAB_OPTIONS: { value: ScanTab; label: string }[] = [
  { value: "all", label: "全項目" },
  { value: "resume", label: "履歴書項目" },
  { value: "card", label: "在留カード項目" },
  { value: "myNumberCard", label: "マイナンバーカード" },
];

/**
 * 3-segment pill control for the unified scan result panel (IROHANA_MATCH_DEV-280).
 * Reuses shared ToggleGroup but overrides its style locally to a pill segmented
 * look (white pill on gray track) per the design mockup — keeps the global
 * ToggleGroup default (primary-blue selected) untouched for other call sites.
 */
export function ScanResultTabs({ state }: Props) {
  const { activeTab, setActiveTab } = state;

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
      <ToggleGroup
        nonControl
        options={TAB_OPTIONS}
        value={activeTab}
        onChange={(_, value) => {
          if (value) setActiveTab(value as ScanTab);
        }}
        sx={{
          width: 480,
          height: 45,
          backgroundColor: "#E6E7E8",
          borderRadius: "999px",
          padding: "4px",
          "& .MuiToggleButton-root": {
            border: "none !important",
            borderRadius: "999px !important",
            backgroundColor: "transparent",
            color: "#5A6063",
            fontFamily: "'Noto Sans JP', sans-serif",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: 0,
            textTransform: "none",
            whiteSpace: "nowrap",
            padding: "0 8px",
            "&:hover": { backgroundColor: "transparent" },
            "&.Mui-selected": {
              backgroundColor: "#FFFFFF !important",
              color: "#2E3436 !important",
              "&:hover": { backgroundColor: "#FFFFFF !important" },
            },
          },
        }}
      />
    </Box>
  );
}
